import React, { useState } from "react";
import { Button, SearchBar, Typography } from "@kitbird/core";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import BankTable from "./components/BankTable";
import ModalBankForm from "./components/BankFormModal";
import ModalBankDelete from "./components/BankDeleteModal";

const Bank = () => {
  const [modalFormBank, setModalFormBank] = useState(false);
  const [modalDeleteBank, setModalDeleteBank] = useState(false);
  const [editValues, setEditValues] = useState<unknown>();

  return (
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Master bank</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium">
              Tabel bank
            </Typography>
          </TitleContent>
          <ActionSection>
            {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
            <SearchBar onInputSearch={() => { }} hasReset placeholder="Cari data" />
            <Button
              onClick={() => setModalFormBank(true)}
              leftIcon={<PlusIcon />}
            >
              Tambah data
            </Button>
          </ActionSection>
          <StickyTable>
            <BankTable
              showModal={() => setModalFormBank(true)}
              showDeleteModal={() => setModalDeleteBank(true)}
              setEditValue={setEditValues}
            />
          </StickyTable>
        </CardContent>
      </PageCard>
      <ModalBankForm
        isOpen={modalFormBank}
        value={editValues}
        setClose={(modalState) => {
          setModalFormBank(modalState);
          setEditValues(undefined);
        }}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit={() => { }}
      />
      <ModalBankDelete
        isOpen={modalDeleteBank}
        value={editValues}
        setClose={(modalState) => {
          setModalDeleteBank(modalState);
          setEditValues(undefined);
        }}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit={() => { }}
      />
    </PageWrapper>
  );
};

export default Bank;
